/*=========================================================================================
  File Name: getters.js
  namespace: courses
  Description: Vuex Store - Course getters
==========================================================================================*/

const getters = {

  getCurrentCourse: state => {
    return state.currentCourse
  },
  getCourseStructure: state => {
    return state.content
  },
  courseIsPublished: state => {
    return state.currentCourse.status !== state.COURSE_POSSIBLE_STATUS.PUBLISHED
  },
  getCoursePossibleStatus: state => {
    return state.courseStatusTransitions[state.currentCourse.status].map((value) => {
      return {
        label: value.charAt(0).toUpperCase() + value.slice(1).toLowerCase().replace(/_/g, " "),
        value: value
      }
    })
  },
  getCourseAllStatus: state => {
    return Object.entries(state.COURSE_POSSIBLE_STATUS).map(([, value]) => {
      return {
        label: value.charAt(0).toUpperCase() + value.slice(1).toLowerCase().replace(/_/g, " "),
        value: value
      }
    })
  },
  getCourseStatusList: state => {
    return state.COURSE_POSSIBLE_STATUS
  },
  getCourseDifficulties: state => {
    return Object.entries(state.COURSE_POSSIBLE_DIFFICULTY).map(([, value]) => {
      return {
        label: value.charAt(0).toUpperCase() + value.slice(1).toLowerCase(),
        value: value
      }
    })
  },
  getCourseEntries: state => {
    return state.courseList
  },
  getCourseList: state => {
    return {
      results: state.results,
      count: state.count
    }
  },
  getCurrentCourseFiles: state => {
    return state.currentCourseFiles
  },
  getStatusTransitions: state => {
    return state.courseStatusTransitions
  },
  getCurrentCoursePasses: state => {
    return state.currentCourse.direct_passes
  },
  getHundredCourses: state => {
    return state.hundredCourses
  },
}

export default getters
